import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Pessoa } from '../classes/Pessoa';

@Injectable({
  providedIn: 'root'
})
export class PessoaService {

  constructor(private http: HttpClient) { }

  getList(): Observable<any>{
    return this.http.get(`${environment.apiURL}/pessoa`)
  }

  get(id:number): Observable<any>{
    return this.http.get(`${environment.apiURL}/pessoa/${id}`)
  }

  post(pessoa: Pessoa): Observable<any>{
    return this.http.post(`${environment.apiURL}/pessoa`, pessoa);
  }

  put(id: number, pessoa: Pessoa): Observable<any>{
    return this.http.put(`${environment.apiURL}/pessoa/${id}`, pessoa);
  }

  delete(id: number): Observable<any>{
    return this.http.delete(`${environment.apiURL}/pessoa/${id}`);
  }

  getCNPJ(cnpj: string): Observable<any>{
    return this.http.get(`${environment.apiURL}/pessoa/brasilApi/${cnpj}`);
  }

  listarFornecedores(): Observable<Pessoa[]>{
    return this.http.get<Pessoa[]>(`${environment.apiURL}/pessoa/fornecedores`);
  }

  postFornecedor(fornecedor: Pessoa): Observable<any>{
    return this.http.post(`${environment.apiURL}/pessoa/fornecedores`, fornecedor);
  }

  putFornecedor(id: number, fornecedor: Pessoa): Observable<any>{
    return this.http.put(`${environment.apiURL}/pessoa/fornecedores/${id}`, fornecedor);
  }

  deleteFonecedores(ids: number[]): Observable<any>{
    const params = ids.map(id => `ids=${id}`).join('&');
    return this.http.delete(`${environment.apiURL}/pessoa/fornecedores?${params}`);
  }

  ativarFornecedor(ids: number[]): Observable<any>{
    return this.http.put(`${environment.apiURL}/pessoa/fornecedores/ativar`, ids);
  }
  inativarFornecedor(ids: number[]): Observable<any>{
    return this.http.put(`${environment.apiURL}/pessoa/fornecedores/inativar`, ids);
  }
}
